import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=f754cad2&scoped=true&"
import script from "./ProductGroup.vue?vue&type=script&lang=ts&"
export * from "./ProductGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGroup.vue?vue&type=style&index=0&id=f754cad2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f754cad2",
  null
  
)

export default component.exports